import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Product from '../../components/Product/Product';
import Loading from '../../components/Loading/Loading';
import {getPreviouslyPurchased} from '../../actions/previouslyPurchased.action';
import {NoItemsAvailable} from './PreviouslyPurchasedPage.style';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  ANALYTICS_SOURCES,
  PREVIOUSLY_PURCHASED_PARAMS,
  ROUTES,
  SCROLL_THRESHOLD,
  SEARCH_SORT_OPTIONS,
  SEARCH_SORT_TYPE,
  getInitialPageSize,
} from '../../constants/constants';
import {syncBasketQuantityWithProducts} from '../../helpers/product.helper';
import {getFilterPillItems} from '../../helpers/data.helper';
import {setCurrentRoute} from '../../actions';
import ToTheTop from '../../components/ToTheTop/ToTheTop';
import {setPrevRoute} from '../../actions/prevRoute.action';
import {toggleNewOfferModal} from '../../actions/modal.action';
import {
  BreadCrumb,
  BreadCrumbLinks,
  ClearFilter,
  Container,
  CurrentPage,
  DoneButton,
  FilterButton,
  FilterButtonWrapper,
  FilterInfo,
  FilterOverlayBackdrop,
  FilterPill,
  FilterPillsWrapper,
  FiltersButtons,
  FiltersScrollArea,
  FiltersWrapper,
  NameWrapper,
  ProductCount,
  ResultsPanel,
  ResultsTitle,
  ResultsWrapper,
  Separator,
  SortButton,
  SortDropdownItem,
  SortDropdownPanel,
  SortWrapper,
  Status,
  ToolBar,
} from '../SearchPage/SearchPage.style';
import Filters from '../../components/Filters/Filters';
import {LeftLine, RightLine} from '../../styles/components/lines';

class PreviouslyPurchasedPage extends PureComponent {
  state = {
    params: {...PREVIOUSLY_PURCHASED_PARAMS, size: getInitialPageSize()},
    showFilterInMobile: false,
    showSortDropdown: false,
    sortType: null,
  };

  sortWrapperRef = React.createRef();
  filtersScrollRef = React.createRef();
  _savedScrollY = 0;

  lockBodyScroll = () => {
    this._savedScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  };

  unlockBodyScroll = () => {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, this._savedScrollY);
  };

  toggleFilterInMobile = () =>
    this.setState(
      prev => ({showFilterInMobile: !prev.showFilterInMobile}),
      () => {
        if (this.state.showFilterInMobile) {
          this.lockBodyScroll();
          if (this.filtersScrollRef.current) {
            this.filtersScrollRef.current.scrollTop = 0;
          }
        } else {
          this.unlockBodyScroll();
        }
      }
    );

  closeFilterInMobile = () => {
    this.setState({showFilterInMobile: false});
    this.unlockBodyScroll();
  };

  applyFilters = () => {
    this.closeFilterInMobile();
  };

  updateSearchParams = updatedParams => {
    const params = {...this.state.params, ...updatedParams};
    this.setState({params});
    this.props.getPreviouslyPurchased(0, params);
  };

  clearFilters = () => {
    const {
      sizeOrCut,
      origin,
      brand,
      productFeatures,
      category,
      ...baseParams
    } = this.state.params;
    this.setState({params: baseParams});
    this.props.getPreviouslyPurchased(0, baseParams);
    window.scrollTo(0, 150);
  };

  handleSortOutsideClick = e => {
    if (
      this.sortWrapperRef.current &&
      !this.sortWrapperRef.current.contains(e.target)
    ) {
      this.setState({showSortDropdown: false});
    }
  };

  toggleSortDropdown = () =>
    this.setState(prev => ({showSortDropdown: !prev.showSortDropdown}));

  selectSort = value => {
    const {getPreviouslyPurchased} = this.props;
    const params = {...this.state.params, sortType: value};
    this.setState({sortType: value, params, showSortDropdown: false});
    getPreviouslyPurchased(0, params);
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleSortOutsideClick);
    const {
      getPreviouslyPurchased,
      setCurrentRoute,
      prevRoute,
      history,
      toggleNewOfferModal,
      modal,
    } = this.props;
    if (prevRoute === null && modal.newOffers === undefined) {
      toggleNewOfferModal(true);
    }
    const isNewSearch =
      history.location &&
      history.location.state &&
      history.location.state.newSearch;
    setCurrentRoute(ROUTES.RECENT_PURCHASES);
    if (prevRoute === ROUTES.PRODUCT && !isNewSearch) {
      return;
    }
    getPreviouslyPurchased(this.state.params.page, this.state.params);
  }

  componentDidUpdate(prevProps) {
    const {auth, getPreviouslyPurchased} = this.props;
    if (auth && auth !== prevProps.auth) {
      getPreviouslyPurchased(this.state.params.page, this.state.params);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleSortOutsideClick);
  }

  loadMore = () => {
    const {getPreviouslyPurchased, previouslyPurchased} = this.props;
    const {params} = this.state;
    getPreviouslyPurchased(previouslyPurchased.page.number + 1, params);
  };

  render() {
    const {
      basket,
      previouslyPurchased,
      loading,
      branch,
      updateBasket,
      updateItem,
      removeItem,
      basketHashMap,
      onProductClick,
      deviceInfo,
      keywordSearch,
      setPrevRoute,
      aggression,
    } = this.props;
    const navToProduct = itemId => {
      setPrevRoute(ROUTES.RECENT_PURCHASES);
      onProductClick(itemId);
    };
    const previouslyPurchasedItems =
      (previouslyPurchased &&
        previouslyPurchased._embedded &&
        previouslyPurchased._embedded.products &&
        syncBasketQuantityWithProducts(
          basketHashMap,
          previouslyPurchased._embedded.products
        )) ||
      [];
    const renderLoading = loading && loading.gettingProducts && (
      <Loading isLight={false} />
    );
    const renderPreviouslyPurchased =
      previouslyPurchasedItems && previouslyPurchasedItems.length > 0 ? (
        previouslyPurchasedItems.map((product, index) => (
          <Product
            product={product}
            branch={branch}
            key={product.itemId + index}
            searchId={product._searchId}
            searchPosition={index}
            onProductClick={navToProduct}
            loading={loading}
            basketHashMap={basketHashMap}
            updateBasket={updateBasket}
            updateItem={updateItem}
            removeItem={removeItem}
            fulfillmentType={basket && basket.fulfillmentType}
            deviceInfo={deviceInfo}
            keywordSearch={keywordSearch}
            source={ANALYTICS_SOURCES.PREVIOUSLY_PURCHASED}
          />
        ))
      ) : (
        <NoItemsAvailable>
          No previously purchased items available
        </NoItemsAvailable>
      );
    const renderGoTop = previouslyPurchased &&
      previouslyPurchased.page &&
      previouslyPurchased.page.number > 0 && <ToTheTop />;
    const hasMore =
      previouslyPurchased &&
      previouslyPurchased.page &&
      previouslyPurchased.page.number < previouslyPurchased.page.totalPages - 1;
    const renderContent = (
      <InfiniteScroll
        next={this.loadMore}
        hasMore={hasMore}
        dataLength={previouslyPurchasedItems.length}
        scrollThreshold={SCROLL_THRESHOLD}
        loader={<Loading isLight={false} />}
      >
        {renderPreviouslyPurchased}
      </InfiniteScroll>
    );
    const {showSortDropdown, showFilterInMobile, params} = this.state;
    const activeSortType = this.state.sortType || SEARCH_SORT_TYPE.RELEVANCE;

    const appliedFilters = {
      sizeOrCut: !!params.sizeOrCut,
      origin: !!params.origin,
      brand: !!params.brand,
      productFeatures: !!params.productFeatures,
      categoryList: !!params.category,
    };

    const totalElements =
      previouslyPurchased &&
      previouslyPurchased.page &&
      previouslyPurchased.page.totalElements;

    const renderFilterButton = previouslyPurchasedItems.length > 0 && (
      <FilterButtonWrapper>
        <FilterButton onClick={this.toggleFilterInMobile}>
          {showFilterInMobile ? 'Hide Filters' : 'Show Filters'}
          <Status $selected={showFilterInMobile} />
        </FilterButton>
      </FilterButtonWrapper>
    );

    const renderFilters = aggression && (
      <Filters
        params={params}
        updateSearchParams={this.updateSearchParams}
        filters={aggression}
        appliedFilters={appliedFilters}
        showInMobile={showFilterInMobile}
        isCategorySearch={false}
        isCurrentSearch={true}
        closedByDefault={true}
      />
    );

    const renderFilterTitle = totalElements > 0 && (
      <FilterInfo>
        <span>{`Filter ${totalElements} products by:`}</span>
        <ClearFilter onClick={this.clearFilters}>clear filters</ClearFilter>
      </FilterInfo>
    );

    const filterPillItems = getFilterPillItems(aggression);
    const renderFilterPills = filterPillItems.length > 0 && (
      <FilterPillsWrapper>
        <div>
          {filterPillItems.map(({id, name, unqueryParams}) => (
            <FilterPill
              key={id}
              onClick={() => this.updateSearchParams(unqueryParams)}
            >
              {name}
            </FilterPill>
          ))}
        </div>
      </FilterPillsWrapper>
    );

    const renderFiltersWrapper = previouslyPurchasedItems.length > 0 && (
      <FiltersWrapper $showInMobile={showFilterInMobile}>
        <FiltersScrollArea ref={this.filtersScrollRef}>
          {renderFilterTitle}
          {renderFilters}
        </FiltersScrollArea>
        <FiltersButtons>
          <DoneButton onClick={this.applyFilters}>Apply Filters</DoneButton>
        </FiltersButtons>
      </FiltersWrapper>
    );

    return (
      <Fragment>
        <BreadCrumb>
          <span>
            <BreadCrumbLinks to="/">Home</BreadCrumbLinks>
            <Separator> › </Separator>
            <CurrentPage $noPadding>My Recent Purchases</CurrentPage>
          </span>
          {totalElements > 0 && (
            <ProductCount>{totalElements} Products found</ProductCount>
          )}
        </BreadCrumb>
        <ToolBar>
          <SortWrapper ref={this.sortWrapperRef}>
            <SortButton onClick={this.toggleSortDropdown}>
              {`Sort: ${
                (
                  SEARCH_SORT_OPTIONS.find(o => o.value === activeSortType) ||
                  SEARCH_SORT_OPTIONS[0]
                ).label
              }`}
            </SortButton>
            {showSortDropdown && (
              <SortDropdownPanel>
                {SEARCH_SORT_OPTIONS.map(opt => (
                  <SortDropdownItem
                    key={opt.value}
                    $active={activeSortType === opt.value}
                    onClick={() => this.selectSort(opt.value)}
                  >
                    {opt.label}
                  </SortDropdownItem>
                ))}
              </SortDropdownPanel>
            )}
          </SortWrapper>
          {renderFilterButton}
        </ToolBar>
        <ResultsTitle>
          <LeftLine />
          <NameWrapper>My Recent Purchases</NameWrapper>
          <RightLine />
        </ResultsTitle>
        <Container>
          <FilterOverlayBackdrop
            $show={showFilterInMobile}
            onClick={this.closeFilterInMobile}
          />
          {renderFiltersWrapper}
          <ResultsPanel>
            {renderFilterPills}
            <ResultsWrapper $gridView={true} $maxColumns={4}>
              {renderContent}
              {renderLoading}
            </ResultsWrapper>
          </ResultsPanel>
          {renderGoTop}
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  previouslyPurchased: state.previouslyPurchased,
  auth: state.auth,
  loading: state.loading,
  prevRoute: state.prevRoute,
  modal: state.modal,
  aggression: state.aggression,
});

const mapDispatchToProps = dispatch => ({
  getPreviouslyPurchased: bindActionCreators(getPreviouslyPurchased, dispatch),
  setCurrentRoute: bindActionCreators(setCurrentRoute, dispatch),
  setPrevRoute: bindActionCreators(setPrevRoute, dispatch),
  toggleNewOfferModal: bindActionCreators(toggleNewOfferModal, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviouslyPurchasedPage);
